// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3z7r5","choiceBoxes":"toolbarselects_choiceBoxes__2mtAv","simpleField":"toolbarselects_simpleField__uwkJA"};